import { css } from '@emotion/react'
import { Button, Flow, Icon, Tooltip } from 'bold-ui'
import { Box } from 'components/Box'
import { ContextualHelpCard } from 'components/ContextualHelpCard'
import { useFlags } from 'config/useFlagsContext'
import ilustracaoCitoMama from 'images/atendimento/requisicao-exames/Ilustracao_cito_mama.svg'

interface ExamesTableSubheaderProps {
  imprimirTooltip: string
  disabledImpressao: boolean
  handleImpressao: () => void
}

export default function ExamesTableSubheader(props: Readonly<ExamesTableSubheaderProps>) {
  const { imprimirTooltip, disabledImpressao, handleImpressao } = props

  const { PILOTO_SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED } = useFlags()

  return (
    <Flow direction='vertical'>
      {PILOTO_SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED && (
        <ContextualHelpCard
          title='Está disponível a requisição de exame citopatológico de colo uterino no padrão SISCAN'
          description='O preenchimento e impressão das requisições podem ser acessados através das opções na solicitação do exame
            adicionado'
          imageHeight={80}
          showVerMais={false}
          image={ilustracaoCitoMama}
          storageKey='contextual-help-card/requisicao-exame-citopatologico-uterino'
        />
      )}

      <Box style={styles.box}>
        <Tooltip text={imprimirTooltip} placement='bottom'>
          <Button kind='normal' size='small' onClick={handleImpressao} disabled={disabledImpressao}>
            <Flow direction='horizontal' gap={0.5}>
              <Icon icon='printerOutline' />
              Imprimir registrado agora
            </Flow>
          </Button>
        </Tooltip>
      </Box>
    </Flow>
  )
}

const styles = {
  box: css`
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem;
  `,
}
